import React, { useState, useEffect, useContext } from "react"
import { container, complete, terms, inputCheck } from "./personal.module.css"
import Button from "src/components/core/atoms/button"
import { CartContext } from "src/context/CartContext"
import { UserContext } from "src/context/UserContext"
import { InputValidations } from "src/services/inputValidations"
import { navigate } from "gatsby"

import Info from "./info"

const InfoPersonal = ({ setSnackbarVisibility }) => {
  const { cartData, locations, dateTimes, dispatchCart, ACTIONS } = useContext(
    CartContext
  )
  const { authUser, user, addNewBooking } = useContext(UserContext)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [errors, setErrors] = useState({})
  const [values, setValues] = useState({
    email: "",
    firstName: "",
    secondName: "",
    phoneNumber: "",
    password: "",
    passwordValidation: "",
    jobReferenceNumber: "",
    roleProductionCompany: "",
    crewSize: 0,
    notes: "",
    termsAgreed: "",
  })

  useEffect(() => {
    return authUser && user ? setIsLoggedIn(true) : setIsLoggedIn(false)
  }, [authUser, user])

  const updateValues = React.useCallback(() => {
    setValues(prevState => ({
      ...prevState,
      email: user.email,
      firstName: user.firstName,
      secondName: user.secondName,
      phoneNumber: user.phoneNumber,
      termsAgreed: "",
    }))
  }, [setValues, user])

  useEffect(() => {
    if (isLoggedIn) updateValues()
    return () => {
      setValues({})
      setErrors({})
    }
  }, [isLoggedIn, updateValues])

  useEffect(() => {
    const errs = InputValidations(values)
    setErrors(errs)
  }, [values])

  const doSubmit = async e => {
    e.preventDefault()
    let meetsAllRequirements = false
    if (isLoggedIn) {
      meetsAllRequirements =
        Object.keys(errors).toString() ===
        ["password", "passwordValidation"].toString()
    } else {
      meetsAllRequirements = !Object.keys(errors).length
    }

    if (!meetsAllRequirements) {
      setSnackbarVisibility(true)
      setTimeout(() => setSnackbarVisibility(false), 5000)
    } else {
      const res = await addNewBooking(values, cartData, locations, dateTimes)
      if (res.status === 200) {
        dispatchCart({ type: ACTIONS.CART_CLEAR })
        navigate("/services/booking/complete", {
          state: { res: JSON.stringify(res) },
        })
        return
      } else {
        setSnackbarVisibility(true)
        setTimeout(() => setSnackbarVisibility(false), 5000)
      }
    }
  }

  const checkTerms = e => {
    setValues({
      ...values,
      termsAgreed: e.target.checked,
    })
  }

  return (
    <form onSubmit={doSubmit}>
      <div className={container}>
        <Info.PersonalDetails
          input={{ values, setValues, errors }}
          isLoggedIn={isLoggedIn}
        />
        <Info.JobDetails input={{ values, setValues, errors }} />
      </div>
      <div className={complete}>
        <div>
          <span id={terms}>
            <input
              name="termsAgreed"
              type="checkbox"
              className={inputCheck}
              checked={values.termsAgreed}
              onChange={checkTerms}
            />
            <label htmlFor="terms-and-conditions">
              I have read and agree to the
              <Button variant="underlined" type="button" onClick={() => {}}>
                website terms and conditions.
              </Button>
            </label>
          </span>
        </div>
        <Button type="submit" variant="solid">
          Complete Booking
        </Button>
      </div>
    </form>
  )
}

export default InfoPersonal
